export default "__VITE_ASSET__d8GLAszC__"